import moment from "moment";

export const userDetail = () => {
  let userDetail = JSON.parse(localStorage.getItem("userProfile"));
  return {
    id: userDetail ? userDetail.id : "",
    parentFarmId: userDetail ? userDetail.parentFarmId : "",
    name: userDetail ? `${userDetail.firstName}  ${userDetail.lastName}` : "",
    roleName: userDetail ? userDetail.roleName : "",
    username: userDetail ? userDetail.username : "",
    planId: userDetail ? userDetail.subscriptionId : "",
    firstName: userDetail ? userDetail.firstName : "",
    lastName: userDetail ? userDetail.lastName : "",
    subscriptionId: userDetail ? userDetail.subscriptionId : "",
    town:
      userDetail && userDetail.farmResponseDTO
        ? userDetail.farmResponseDTO.address.town
        : "",
    state:
      userDetail && userDetail.farmResponseDTO
        ? userDetail.farmResponseDTO.address.state
        : "",
    country:
      userDetail && userDetail.farmResponseDTO
        ? userDetail.farmResponseDTO.address.country || "United States"
        : "United States",
    zipCode:
      userDetail && userDetail.farmResponseDTO
        ? userDetail.farmResponseDTO.address.zipCode
        : "",
    streetAddress:
      userDetail && userDetail.farmResponseDTO
        ? userDetail.farmResponseDTO.address.streetAddress
        : "",
    contactNo: userDetail ? userDetail.contactNo : "",
    userId: userDetail ? userDetail.externalUserId : "",
    endDate: userDetail ? moment(userDetail.endDate * 1000).format("ll") : "",
    paymentStatus: userDetail ? userDetail.paymentStatus : null,
    stripeUser: userDetail ? userDetail.stripeUser : null,
  };
};

// function capitalizeFirstLetter(string) {
//     return string.charAt(0).toUpperCase() + string.slice(1);
// }



// WEBPACK FOOTER //
// ./src/config/userDetails.js